import { getAttributionCookie } from 'lib/@getethos/analytics/getAttributionCookie'
import { getQueryString } from 'lib/@getethos/utils/utils'

export const useGetQueryParam = (params: string): string | null | undefined => {
  const attributionCookie = getAttributionCookie() as Record<string, any>
  const queryParams = getQueryString()

  return queryParams?.[params] || attributionCookie[params]
}
